import React, { useState, useEffect } from "react";
import { 
    Flex,
    Button 
} from "@chakra-ui/react";

const topWin = 150;

const Navigation = ({color}: {color: string}) => {
    const [info, setInfo] = useState<HTMLElement | null>(null);
    const [graph, setGraph] = useState<HTMLElement | null>(null);
    const [detail, setDetail] = useState<HTMLElement | null>(null);
    const [olymps, setOlymps] = useState<HTMLElement | null>(null);
    const [similar, setSimilar] = useState<HTMLElement | null>(null);
    const [interest, setInterest] = useState<HTMLElement | null>(null);
    const [plan, setPlan] = useState<HTMLElement | null>(null);
    const [video, setVideo] = useState<HTMLElement | null>(null);
    const [professions, setProfessions] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setInfo(document.getElementById('info'));
        setGraph(document.getElementById('graph'));
        setDetail(document.getElementById('details'));
        setOlymps(document.getElementById('olympiads'));
        setPlan(document.getElementById('plan'));
        // setSimilar(document.getElementById('similar'));
        setInterest(document.getElementById('interest'));
        setProfessions(document.getElementById('professions'));
    }, [])

    return(
        <Flex 
            w='100%'
            flexWrap='wrap'
            px={{
                base: '24px', 
                xl: '100px'
              }}
            fontSize='18px'
            pt='20px'
            gap='10px' 
            as='b'>
            {info && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: info.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Информация о программе
                </Button>
            }
            {graph && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: graph.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Динамика проходного балла
                </Button>
            }
            {detail && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: detail.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Подробная информация
                </Button>
            }
            {professions && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: professions.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Карта профессий
                </Button>
            }
            {plan && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: plan.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Учебный план
                </Button>
            }
            {olymps && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: olymps.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Олимпиады
                </Button>
            }
            {interest && 
                <Button
                    bg='none'
                    border={`1px solid ${color}`}
                    borderRadius='40px' 
                    onClick={() => {
                        window.scrollTo({
                            top: interest.getBoundingClientRect().top - topWin, // прокручиваем на 100 пикселей вниз
                            behavior: 'smooth', // добавляем плавную анимацию прокрутки
                        });
                    }}
                >
                    Вам может быть интересно
                </Button>
            }
        </Flex>
    )
}

export default Navigation;